<template>
    <div id= "ia-middlesmall" style="margin-bottom: 5px;">
      <div id="ia-pgnHeader"></div> 
      <div id="ia-pgnButtons"></div>
      <div id="ia-pgnError"></div>
      <p></p>
      <div id="ia-boardsmall" style="width:100%; height:60px;" :class="classboard">
      </div>
      <div id="pgnMovesIA"></div>
    </div>
</template>
<script>
// import Chess from 'chess.js'
import UserService from '../../services/user'
import Store from '../../services/lstorage'
// import Chessground from 'chessground'
// import Garbochess from '../../services/garbochess.js'
// import UserService from '../../services/user'
// import BoardHistory from '../game/boardHistory'
// import toast from 'vue-material-components'
// import Jquery from 'jquery'
// var intervalSmall = []
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
export default {
  name: 'BoardVisorIa',
  props: {
    game: {
      type: Object
    },
    classboard: {
      type: String
    },
    pgn: {
      type: String
    }
  },
  data () {
    return {
      // chess: new Chess(),
      styleboard: true,
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      user: UserService.user,
      turnSmall: '',
      gameActual: []
    }
  },
  components: {
  },
  mixins: [
    // toast
  ],
  events: {
    updatePgnIA (pgn) {
      setTimeout(function () {
        // window.alert(pgn)
        this.loadDataGame(pgn)
      }.bind(this), 50)
    }
  },
  methods: {
    /* deleteComment (pgn) {
      pgn = pgn.replace(/\{(.*?)\}/gmu, '')
      pgn = pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      pgn = pgn.replace(/\{(\s\S.+?)\}/gmu, '')
      return pgn
    },*/
    prettyPgn (texto) {
      // texto = texto.replace(/\r?\n/g, ' ').replace(/\s+/g, ' ') // Asegura que no queden múltiples espacios
      // window.alert(texto)
      // str = str.replace(/\u2605/g, '').replace(/\u0445/g, 'x')
      // str = ' ' + str.replace(/\./g, ' ').replace(/(\[FEN [^\]]+\])+?/g, function ($0, $1) { return $1.replace(/\[|\]|"/g, '').replace(/\s/g, '.') })
      // str = str.replace(/\[Event /g, '* [Event ').replace(/\s(\[[^\]]+\])+?/g, '').replace(/(\{[^\}]+\})+?/g, '')
      /* var r = /(\([^\(\)]+\))+?/g
      while (r.test(str)) {
        str = str.replace(r, '')
      }*/
      // window.alert(str)
      // str = decodeURIComponent((str))
      return texto
      // return Buffer.from(texto, 'latin1').toString('utf8')
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') */ && linea[0] !== '*') {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    parse_pgn_header (header, wordBreak = '') {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0) {
          headerObj[key] = value
          if (key === wordBreak) {
            break
          }
        }
      }
      return headerObj
    },
    changeStateGame (pgn, id, fen) {
      pgn = this.prettyPgn(pgn)
      if (document.getElementById('ia-boardsmall') !== null) {
        var Width = document.getElementById('ia-middlesmall').clientWidth
        // window.alert(pgn)
        var pos = 'start'
        var start = fen !== undefined ? fen : ''
        // pgn = this.deleteComment(pgn)
        var headers = this.parse_pgn_header(pgn, 'FEN')
        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
          pos = (fen !== undefined && fen !== 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') ? fen : headers['FEN']
          if (!this.hasBody(pgn)) {
            start = ''
            pos = headers['FEN']
          }
          if (pos === headers['FEN']) {
            start = ''
          }
          start = ''
          pos = headers['FEN']
        }
        if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
          start = ''
          pos = fen
        }
        if (document.getElementById('pgnMovesIA')) {
          document.getElementById('pgnMovesIA').textContent = ''
        }
        if (document.getElementById('ia-pgnButtons')) {
          document.getElementById('ia-pgnButtons').textContent = ''
        }
        if (document.getElementById('ia-pgnComment')) {
          document.getElementById('ia-pgnComment').textContent = ''
        }
        if (document.getElementById('ia-pgnHeader')) {
          document.getElementById('ia-pgnHeader').textContent = ''
        }
        if (document.getElementById('ia-pgnError')) {
          document.getElementById('ia-pgnError').textContent = ''
        }
        // window.alert(pgn)
        // window.alert(pos + ' - ' + start + ' - ' + fen)
        if (Width > 0 && fen !== undefined && typeof window.pgnBoard === 'function') {
          window.pgnEdit({inner: 'ia-boardsmall', button: 'ia-pgnButtons', fen: 'ia-pgnFen', header: 'ia-pgnHeader', error: 'ia-pgnError', moves: 'pgnMovesIA'}, {pgn: pgn, position: pos, startPlay: start, showCoords: false, width: Width})/* , orientation: (this.turnSmall === 'w') ? 'white' : 'black'} */
        } else {
          window.pgnEdit({inner: 'ia-boardsmall', button: 'ia-pgnButtons', fen: 'ia-pgnFen', header: 'ia-pgnHeader', error: 'ia-pgnError', moves: 'pgnMovesIA'}, {pgn: pgn, position: 'start', showCoords: false, width: Width})
        }
      }
      const comments = document.querySelectorAll('.afterComment')
      comments.forEach((comment) => {
        // Verifica si el texto del comentario contiene el emoji 🎥
        const textResource = comment.textContent.toLowerCase()
        if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
          // Añade la clase .highlight-move al elemento padre con clase .move
          comment.closest('.move').classList.add('highlight-move')
        }
      })
    },
    /* prettyPgn (str) {
      // str = str.replace(/\u2605/g, '').replace(/\u0445/g, 'x')
      // str = ' ' + str.replace(/\./g, ' ').replace(/(\[FEN [^\]]+\])+?/g, function ($0, $1) { return $1.replace(/\[|\]|"/g, '').replace(/\s/g, '.') })
      // str = str.replace(/\[Event /g, '* [Event ').replace(/\s(\[[^\]]+\])+?/g, '').replace(/(\{[^\}]+\})+?/g, '')
      /* var r = /(\([^\(\)]+\))+?/g
      while (r.test(str)) {
        str = str.replace(r, '')
      }*
      // str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O').replace(/(1\-0|0\-1|1\/2\-1\/2)/g, ' * ').replace(/\s\d+/g, ' ').replace(/\$\d+/g, '').replace(/\?/g, '')
      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O')
      // window.alert(str)
      return str
    },*/
    loadDataGame (pgn, force = false) {
      // var pgn = board.pgn.replace(/"]/g, '"]\n')
      // board.pgn = board.pgn.replace(/'"]/g, '"]\n')
      // board.pgn = board.pgn.replace(/'{}'/g, '')
      if (pgn.length <= 0) {
        this.pgn = pgn
      }
      this.pgn = this.prettyPgn(this.pgn)
      // board.pgn = board.pgn.replace(/\{( *)\}/gmu, '')
      // board.pgn = board.pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      // board.pgn = board.pgn.replace(/\{\[%clk(\s\S.+?)\]\}/gmu, '')
      // pgn = unescape(board.pgn)
      // this.chess.load_pgn(board.pgn)
      // window.alert(board.pgn)
      // this.turnSmall = this.chess.turn()
      this.changeStateGame(this.pgn, this.game._id ? this.game._id : this.game.id, 'start')
      this.$nextTick(function () {
        var buttonFirst = document.getElementById('ia-pgnButtonsfirst')
        if (buttonFirst) {
          // window.alert(buttonFirst)
          buttonFirst.click()
        }
      })
      this.$nextTick(function () {
        var buttonFirst = document.getElementById('ia-pgnButtonsprev')
        if (buttonFirst) {
          // window.alert(buttonFirst)
          buttonFirst.click()
        }
      })
      // this.changeStateGame(board._id, this.chess.fen(), pgn)
    }
  },
  watch: {
    game (newVal, oldVal) {
      // window.alert(newVal)
      if (newVal !== oldVal) {
        this.loadDataGame(this.pgn, true)
      }
    },
    pgn (newVal, oldVal) {
      // window.alert(newVal)
      if (newVal !== oldVal) {
        this.loadDataGame(newVal, true)
      }
    }
  },
  beforeDestroy () {
    this.game._id = this.game._id ? this.game._id : this.game.id
    // clearInterval(intervalSmall[this.game._id])
  },
  beforeCreate () {
    // console.log('beforeCreate')
  },
  created () {
    // window.alert(this.pgn)
    setTimeout(function () {
      if (this.game._id) {
        this.gameActual[this.game._id] = this.game
      }
      this.game._id = this.game._id ? this.game._id : this.game.id
      this.loadDataGame(this.game, true)
    }.bind(this), 500)
  },
  init () {
    // console.log('init')
  },
  updated () {
    // console.log('updated')
  },
  destroyed () {
    // console.log('beforeDestroy')
  }
  /* compiled () {
    // console.log('compiled')
  }*/
}
</script>

<style scoped>
  @import '../../../static/libs/simplechessboard.min.css';
  .userTurn {
    color: white ;
    font-size: large;
  }
  .borderWhite {
    border: 7px solid white;
  }
  .borderBlack {
    border: 7px solid black;
  }
  .check {
    background: radial-gradient(ellipse at center, rgb(123, 255, 0) 40%, rgba(231, 0, 0, 1) 40%, rgba(169, 0, 0, 0) 89%, rgba(158, 0, 0, 0) 100%);
  }
  #ia-pgnHeader {
    font-size: smaller;
  }
</style>



// WEBPACK FOOTER //
// boardVisorIa.vue?3ed9a705